import { useMutation } from '@tanstack/react-query';
import { captureException } from '@sentry/react';
import { CustomError } from 'typescript/utilities/custom_error';
import { createFinancingDisclosures as clientCreateFinancingDisclosures } from 'typescript/clients/solidshop/financing_disclosures_client';
import { MUTATION_KEYS } from 'typescript/constants/react_query';
import { CountryCode, LanguageCode } from 'typescript/constants/localization';
import { useLocaleInfo } from 'typescript/context/locale_info';

const useCreateFinancingDisclosures = ({
  orderNumber,
}: {
  orderNumber: string;
}) => {
  const { countryCode: contextCountryCode, languageCode: contextLanguageCode } =
    useLocaleInfo();

  const { mutate: createFinancingDisclosure, ...rest } = useMutation({
    mutationKey: [MUTATION_KEYS.FINANCING_DISCLOSURES, { orderNumber }],
    mutationFn: ({
      languageCode = contextLanguageCode,
      countryCode = contextCountryCode,
    }: {
      countryCode?: CountryCode;
      languageCode?: LanguageCode;
    }) =>
      clientCreateFinancingDisclosures({
        languageCode,
        orderNumber,
        countryCode,
      }),
    onError: (error) =>
      captureException(
        new CustomError(MUTATION_KEYS.FINANCING_DISCLOSURES, error),
        {
          extra: {
            orderNumber,
          },
        },
      ),
  });

  return { createFinancingDisclosure, ...rest };
};

export { useCreateFinancingDisclosures };
